module.exports = __webpack_public_path__ + "static/media/01-icon.a4026c83.svg";